import type { ReactNode } from "react";

/**
 * Las barras de la plantilla (`.bars`), escritas a mano: etiqueta, carril y
 * cifra (SPEC 3 prohibe librerias de graficos en `web/`).
 *
 * La longitud se calcula sobre el VALOR ABSOLUTO y el signo lo dice el color y
 * la cifra, que es como lo resuelve la maqueta. Para una lectura acotada, como
 * el acierto, se pasa `max` fijo: si el maximo se dedujera de los datos, un 40 %
 * pintaria la barra entera y se leeria como un pleno.
 */

export type BarItem = {
  label: string;
  value: number;
  display: string;
  color: string;
  /** Clase de tono de la cifra: `up`, `down` o `muted`. */
  tone?: string | undefined;
  /** Se lee bajo la etiqueta cuando hace falta matizar la barra. */
  title?: string | undefined;
};

export function Bars(props: {
  items: readonly BarItem[];
  max?: number | undefined;
  wide?: boolean | undefined;
}): ReactNode {
  const { items } = props;

  if (items.length === 0) {
    return <p className="muted">Sin datos en este periodo.</p>;
  }

  const largest = Math.max(...items.map((item) => Math.abs(item.value)));
  const max = props.max ?? largest;

  return (
    <div className={props.wide === true ? "bars wide" : "bars"}>
      {items.map((item) => (
        <div className="bar" key={item.label}>
          <span className="lbl" title={item.title ?? item.label}>
            {item.label}
          </span>
          <div className="track">
            <div
              className="fill"
              style={{
                width: `${max === 0 ? 0 : Math.round((Math.abs(item.value) / max) * 100)}%`,
                background: item.color,
              }}
            />
          </div>
          <span className={item.tone === undefined ? "val" : `val ${item.tone}`}>
            {item.display}
          </span>
        </div>
      ))}
    </div>
  );
}
